__turbopack_context__.v({
  "label": "SeksjonsListe-module__6o0rHW__label",
  "liste": "SeksjonsListe-module__6o0rHW__liste",
  "noekkel": "SeksjonsListe-module__6o0rHW__noekkel",
  "rad": "SeksjonsListe-module__6o0rHW__rad",
  "rader": "SeksjonsListe-module__6o0rHW__rader",
  "verdi": "SeksjonsListe-module__6o0rHW__verdi",
  "wrapper": "SeksjonsListe-module__6o0rHW__wrapper",
});
